import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
export const PaymentSuccess = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();

  React.useEffect(() => {
    if (!id) {
      navigate("/app", { replace: true });
    } else {
      navigate(`/app/order-placed/${id}`, { replace: true });
    }
  }, [id, location, navigate]);

  return (
    <div className="config-loading">
      <img
        src={process.env.PUBLIC_URL + "/assets/images/loader.gif"}
        style={{ height: "70px", width: "70px", objectFit: "contain" }}
        alt=""
      />
    </div>
  );
};
